// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"408":"0beac7dd","882":"641226f4"}[chunkId] + ".chunk.js";
};